import React from "react";
import {DiReact, DiPython, DiCss3, DiNodejsSmall, DiPostgresql} from "react-icons/di";
import { CgWebsite } from "react-icons/cg";
import styled from "styled-components";
import Card from "./Card";
import { Slide } from "react-awesome-reveal";
import {AiOutlineHtml5} from "react-icons/ai";
import {TbBrandSocketIo} from "react-icons/tb";
import {
  SiSnort,
  SiCloudflare, SiFortinet,
  SiMysql,
  SiPfsense,
  SiProxmox,
  SiSelenium,
  SiWireshark, SiNginx
} from "react-icons/si";
import {BiLogoCPlusPlus, BiLogoGitlab, BiLogoJava} from "react-icons/bi";
import {FaAws, FaDocker} from "react-icons/fa";
import {VscAzure} from "react-icons/vsc";


const Experiences = () => {
  return (
    <Container id="skills">
      <Slide direction="down">
        <h4>
          My <span className="green">Skills</span>
        </h4>
        <h1>What I Can Do</h1>
      </Slide>
      <Cards>
        <Slide direction="left">
          <Card
            Icon={DiReact}
            Icona={DiNodejsSmall}
            Iconc={SiSelenium}
            title={"Full Stack Web Developer"}
            disc={`Incorporated React to making websites more fluid and dynamic.
            Utilized nodeJS & SocketIO for web backend and handling real-time
            applications.  Tested websites with Selenium.`}
          />
        </Slide>
        <Slide direction="right">
          <Card
              Icon={BiLogoCPlusPlus}
              Iconb={DiPython}
              Iconc={BiLogoJava}
            title={"Software Developer"}
            disc={`Developed polymorphic C & C++ apps that use
            algorithms for compression and sandbox configurations.
            Created automation tasks with Python and REST server
            operations in Java with Spring Boot.`}
          />
        </Slide>
        <Slide direction="right">
          <Card
            Icon={SiMysql}
            Icona={FaAws}
            Iconb={DiPostgresql}
            title={"Database Programmer"}
            disc={`Experienced in writing MySQL, Postgres, and AWS' DynamoDB
             database table queries for storing persistent data used by web
             applications and server systems.`}
          />

        </Slide>
        <Slide direction="left">
          <Card
              Icon={FaDocker }
              Icona={SiProxmox}
              Iconb={VscAzure}
              title={"System Configurator"}
              disc={`Configured Docker and Proxmox for multiple web apps (UptimeKuma,
               Gitlab, etc) in Virtual Machines and Containers.
               Utilized Azure's Intune for config policies and app
               deployments on end points`}
          />

        </Slide>
        <Slide direction="left">
          <Card
              Icon={SiWireshark}
              Icona={SiSnort}
              Iconb={SiNginx}
              title={"Security Analyst"}
              disc={`Leveraged WireShark and Snort to identify possible vulnerabilities and
               security risks.  Configured Nginx reverse proxy to apply encryption and
               limiting web accessibility to mitigate risks.`}
          />

        </Slide>
        <Slide direction="right">
          <Card
              Icon={SiPfsense}
              Icona={SiFortinet}
              Iconb={SiCloudflare}
              title={"Network Configurator"}
              disc={`Implemented custom network routing in pfSense and added
              Cloudflare proxy to protect website uptime.  Utilized Fortinet
              VLAN switching to setup dynamic LAN isolation and separation.`}
          />

        </Slide>
      </Cards>
    </Container>
  );
};

export default Experiences;

const Container = styled.div`
  width: 80%;
  max-width: 1280px;
  margin: 0 auto;
  padding: 3rem 0;
  @media (max-width: 840px) {
    width: 90%;
  }

  h1 {
    padding-top: 1rem;
  }
`;
const Cards = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  margin-top: 4rem;
  gap: 1rem;
`;
